import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';

@Component({
    selector: 'app-drag-drop-files',
    templateUrl: './drag-drop-files.component.html',
    styleUrls: ['./drag-drop-files.component.scss'],
    standalone: false
})
export class DragDropFilesComponent implements OnInit {

  files: any[] = [];
  extensionError = false;
  isUploading = false;
  @ViewChild("fileInput") fileInput: ElementRef;
  constructor(private broadcastService: BroadcastService) { }
  /**
   * on file drop handler
   */

  ngOnInit() {
    const fileInfo = new UploadedFileDetails();
    fileInfo.extensionError = this.extensionError;
    fileInfo.files = this.files;
    this.broadcastService.broadcast('extensionError', fileInfo);
    this.broadcastService.subscribe().subscribe(x => {
      if (x.type === 'bulkOrdersUploading') {
          this.isUploading = !this.isUploading;
      }
      if (x.type === 'ResetBulkOrderTemplate') {
       this.clearInput();
    }
    });
  }
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }
    
  clearInput()
  {
    this.fileInput.nativeElement.value = '';
    const fileInfo = new UploadedFileDetails();
    fileInfo.extensionError = this.extensionError;
    this.files = [];
    fileInfo.files = this.files;
    this.isUploading = !this.isUploading;  
    this.broadcastService.broadcast('extensionError', fileInfo);  
 }
 
  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.fileInput.nativeElement.value = '';
    this.extensionError = false;   
    this.files = []; 
    const fileInfo = new UploadedFileDetails();
    fileInfo.extensionError = this.extensionError;
    fileInfo.files = this.files;
    this.broadcastService.broadcast('extensionError', fileInfo);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 50;
          }
        }, 100);
      }
    }, 250);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      this.files = [];       
      item.progress = 0;
      this.files.push(item);
      if(this.files.length > 1) {
        this.files.splice(1, 1);
      }
      const splitNames = this.files[0].name.split('.');
      const extension = splitNames[splitNames.length-1];
      const fileInfo = new UploadedFileDetails();
      fileInfo.files = this.files;
      if (extension !== 'xlsx') {
        this.extensionError = true;
        fileInfo.extensionError = this.extensionError;
      }
      this.broadcastService.broadcast('extensionError', fileInfo);

    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals?) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}

export class UploadedFileDetails{
  extensionError: boolean;
  files: any;
}
